<template lang="pug">
multiselect(
    :options="outlets"
    :multiple="multiple"
    :value="value"
    @input="onInput"
    track-by="id"
    label="name"
    :loading="onLoading('fetch-outlet')"
    :placeholder="placeholder"
    :disabled="disabled"
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        // eslint-disable-next-line vue/require-prop-types
        value: {
            required: true,
        },

        /**
         * Only list outlet in the array given []int
         */
        includeOnly: {
            type: Array,
            default: () => null,
        },

        placeholder: {
            type: String,
            default: 'Select Outlet',
        },

        multiple: {
            type: Boolean,
            default: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters(['outletList']),

        outlets() {
            if (this.includeOnly !== null) {
                return this.outletList.filter(o =>
                    this.includeOnly.includes(o.id),
                );
            }

            return this.outletList;
        },
    },

    mounted() {
        if (!this.outletList.length) {
            this.getOutletList();
        }
    },

    methods: {
        ...mapActions(['getOutletList']),

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/multi-outlet-selector.vue